import cn from "clsx";

import type { TeaserFooter as Footer } from "../../../types/content/teaser";
import type { ArticleStyle } from "../../../types/content";

import styles from "./TeaserFooter.module.scss";
import { Timestamp } from "../../Timestamp/Timestamp";

interface TeaserFooterProps {
  style: ArticleStyle;
  type?: Footer;
  timestamp: string;
}

const TeaserFooterStamp = () => {
  return <span>Omni Mer</span>;
};

const TeaserFooter = ({ style, type, timestamp }: TeaserFooterProps) => {
  if (!type) {
    return null;
  }

  if (type.type === "timestamp") {
    return (
      <div className={cn([styles.teaserFooter, styles.regular, styles[style]])}>
        <Timestamp showRelativeTime={true} dateTime={timestamp} />
      </div>
    );
  }

  if (type.type === "badge") {
    return (
      <div className={cn([styles.teaserFooter, styles[style]])}>
        <TeaserFooterStamp />
      </div>
    );
  }

  return null;
};

export { TeaserFooter };
export type { TeaserFooterProps };
